import { useState } from "react";
import { Link } from "react-router-dom";
import PopupLightbox from "../components/PopupLightbox";

import imgCloseIcon from "../images/icon-close.png";

// import victorB from "../images/bio/alumni/victor-belo.jpg";
// import bryantG from "../images/bio/anonymous.png";
// import robL from "../images/bio/alumni/rob-lewis.jpg";
// import ericaP from "../images/bio/alumni/erica-pugh.jpg";
// import fadiaA from "../images/bio/alumni/fadia-azar.jpg";
// import rachelJ from "../images/bio/alumni/rachel-jepson.jpg";
// import anon from "../images/bio/anonymous.png";
import jeffP from "../images/bio/jeffPickard.jpg";
import ryanS from "../images/bio/ryanS.jpg";
import nicoleD from "../images/bio/nicoleD.jpg";

const FacultyHighlights = () => {
  const [buttonPopup1, setButtonPopup1] = useState(false);
  const [buttonPopup2, setButtonPopup2] = useState(false);
  const [buttonPopup3, setButtonPopup3] = useState(false);
  // const [buttonPopup4, setButtonPopup4] = useState(false);
  // const [buttonPopup5, setButtonPopup5] = useState(false);
  // const [buttonPopup6, setButtonPopup6] = useState(false);

  return (
    <div className="grid-container dark-bg">
      <div className="popup-wrapper">
        <div className="popup-col colB">
          <div className="popup-col-inner">
            <h2>Faculty Highlights</h2>
            <Link className="close-btn" to="/">
              <img src={imgCloseIcon} alt="close button" />
            </Link>

            <ul className="circle-container">
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${nicoleD})` }}
                  onClick={() => setButtonPopup1(true)}
                >
                  <span>Nicole Donahoo</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${jeffP})` }}
                  onClick={() => setButtonPopup2(true)}
                >
                  <span>Jeff Pickered</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${ryanS})` }}
                  onClick={() => setButtonPopup3(true)}
                >
                  <span>Ryan Summerfeldt</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <PopupLightbox trigger={buttonPopup1} setTrigger={setButtonPopup1} columnPosition="colB">
        <h3>Nicole Donahoo</h3>

        <h4>Prompted, Not Planned</h4>
        <br />
        <p>
          For Nicole Donahoo, the path to becoming an assistant professor at the BYU Marriott's School of Accountancy
          began with a breakup—an ordeal that spurred Donahoo to turn to the Lord for guidance. Since then, she’s
          learned that following the promptings of the Lord brings her joy, even when God’s plans are different from
          what she had in mind.
        </p>
        <p>
          “I actually always tell people that I was tricked into doing accounting,” Donahoo says. When Donahoo returned
          home from her mission in Portugal for The Church of Jesus Christ of Latter-day Saints, she was at the mercy of
          the class schedule arranged by her mother, a BYU Marriott MAcc alum. Donahoo—somewhat grudgingly—attended the
          accounting class that she had been signed up for. “My mother was right. I loved it,” Donahoo admits. So, she
          applied to the undergraduate program and later the graduate program in the School of Accountancy.
        </p>
        <p>
          Things seemed to be lining up for Donahoo as she started her last year in the MAcc program: She had a job
          offer at a firm she liked, and she was dating a boy she was excited about. Then, her boyfriend broke up with
          her. Upset, Donahoo turned to the Lord for solace, asking a friend to give her a priesthood blessing.
        </p>
        <p>
          While receiving the blessing, Donahoo felt impressed that Heavenly Father wanted her to get a PhD and become a
          professor. “I called my best friend and was more upset about the fact that I had to go get a PhD than the fact
          that the boy had broken up with me,” she says. “I had other plans for where I saw my life going.”
        </p>
        <p>
          Donahoo decided to begin applying to PhD programs, despite her misgivings. “When I interviewed at the
          University of Illinois Urbana-Champaign [UIUC], I felt very strongly that that’s where I needed to go,” she
          says. Donahoo was nervous about UIUC because there were fewer single members of the Church in the area. “I
          figured I would just stay single for my whole PhD, then hopefully find someone after I moved,” she recalls. “I
          ended up meeting my husband there, in our tiny little single adults branch of, like, ten people.”
        </p>
        <p>
          Once she joined the PhD program, her initial reluctance gradually grew into excitement. “Heavenly Father knows
          me better than I know myself, and he knew being a professor would be a good fit for me,” Donahoo says. The PhD
          program also helped Donahoo realize her love of research.
        </p>
        <p>
          Donahoo’s focus on interview-based research is, by her own admission, somewhat rare in the accounting field.
          She originally picked her research track half out of love for the subject and half out of spite, she jokes:
          “If Heavenly Father wanted me to get a PhD, I was at least going to research what I wanted to, even if I
          thought I probably wouldn’t be able to get a job with it.” Contrary to her own expectations, Donahoo found a
          mentor at UIUC who specialized in a similar area of research and helped her work toward her dream job:
          teaching at BYU Marriott.
        </p>
        <p>
          After graduating from UIUC in 2024, Donahoo accepted a position at BYU Marriott as an assistant professor of
          accountancy. “I love working with the students in the accounting program,” she says. “They’re so smart and so
          committed that they make me step up my game, not only intellectually, but spiritually as well.”
        </p>
        <p>
          Donahoo has found that her students are excited to connect with her and understand what she teaches them.
          “They’re hungry for gospel answers and truth, and they want that in class,” Donahoo says. “That means I have
          to stay on my A game—and I appreciate the challenge; it makes coming to work really fun.”
        </p>
        <p>
          Donahoo hadn’t imagined that she would find so much passion and fun in her work when she originally received
          the prompting to pursue a PhD. “I’ve learned to listen to promptings and trust that God has a better plan for
          me than I have for myself,” Donahoo reflects. “He knows exactly what He’s doing.”
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup2} setTrigger={setButtonPopup2} columnPosition="colB">
        <h3>Jeff Pickered</h3>
        <h4>Trusting in God’s Plans</h4> <br />
        <p>
          When Jeffrey Pickerd graduated from the BYU Marriott School of Business with his bachelor’s and master’s
          degrees in accounting, he knew he wanted to return as a faculty member someday. Now a new associate professor
          in the School of Accountancy, Pickerd has seen the Lord’s hand guiding his journey back to BYU Marriott as he
          continued forward in faith.
        </p>
        <p>
          Pickerd has loved BYU since he was a child, spending the summers on campus with his grandfather, who was a
          faculty member. This childhood love of all things BYU has evolved into a deep admiration for BYU’s mission.
          “BYU is helping The Church of Jesus Christ of Latter-day Saints advance its mission,” he says. “I just want to
          be a part of the work.”{" "}
        </p>
        <p>
          Working toward his goal of returning to BYU and advancing its mission, Pickerd earned his PhD in accounting
          from the University of Massachusetts Amherst. During this time, he met his wife, Britny, through a mutual
          friend.{" "}
        </p>
        <p>
          Pickerd and Britny were both BYU alumni who, to their knowledge, had never met before. As they packed up to
          move in together after their marriage, Britny found a note complimenting her piano playing from more than
          eight years before—signed by Jeffery Pickerd. “So somehow we had met years before at BYU, and I wrote her a
          note and she kept it,” he says. “Think about that—how many nice notes in those young single adult wards do you
          keep?”{" "}
        </p>
        <p>
          The reappearance of Pickerd’s long-lost note confirmed the newlyweds’ faith that God had a hand in their lives
          and knew the best ways for them to proceed. Pickerd leaned on that assurance while he taught at the University
          of Mississippi, dreaming of one day making it back to BYU Marriott. “We were taking every footstep knowing
          that whatever happens will happen,” Pickerd says. “And if what happened wasn’t BYU, we would continue to find
          what the Lord would need us to do.”{" "}
        </p>
        <p>
          While he taught at Ole Miss, Pickerd collaborated with several BYU Marriott faculty to research the use of AI
          in accounting, networking with many people both inside and outside of the SOA. In summer of 2024, his prayers
          and efforts were answered, and Pickerd returned to BYU Marriott with his wife and their three daughters.{" "}
        </p>
        <p>
          Now, Pickerd begins a new journey to find the ways he can best contribute to the SOA. "If this position was
          just about being an accounting professor," he says, "I've done that for eight years. But how to be a BYU
          Marriott accounting professor? What does mission-inspired scholarship and inspired teaching look like? What
          does Christlike service look like?"
        </p>
        <p>
          In order to find answers to his questions, Pickerd has gathered information from speeches given at and about
          BYU. One of the common themes he found was the journey toward “education in Zion,” which requires continual
          improvement and service. He is excited to incorporate these principles into his research and teaching at the
          SOA.{" "}
        </p>
        <p>
          In addition to the Church’s and BYU’s missions, BYU Marriott’s vison, mission, and values are especially
          inspiring to Pickerd. “We’re assisting others in the quest for perfection and eternal life and transforming
          the world through Christlike leadership,” he says. “We’re developing students of faith, intellect, and
          character, with values of integrity in action, respect for all, excellence, and faith in Christ.”
        </p>
        <p>
          He is eager to guide his students on their journeys, just as his mentors helped him. “As a student, I
          benefited greatly from a lot of people who looked at me and saw potential,” he says.
        </p>
        <p>
          Pickerd hopes to live up to his potential and learn how best to serve BYU Marriott and its students as he
          moves forward in faith. “This is a place where things will be accomplished that can’t be done elsewhere,” he
          says. “This is a place of dreams.”
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup3} setTrigger={setButtonPopup3} columnPosition="colB">
        <h3>Ryan Summerfeldt</h3>
        <h4>Teaching Christlike Leadership in Accounting Classrooms</h4>
        <br />
        <p>
          Growing up, Ryan Sommerfeldt wanted to be a high school math teacher, but now, instead of teaching algebra or
          calculus, he is teaching accounting as an assistant professor at the BYU Marriott School of Business with the
          aim of helping students progress both spiritually and intellectually.{" "}
        </p>
        <p>
          Although Sommerfeldt has always enjoyed math and teaching, he ultimately decided that high school teaching
          wasn’t the career he wanted to pursue. He tried out chemistry, then physics, and finally took an accounting
          class at his brothers’ suggestion.
        </p>
        <p>
          “Everybody else talked about how hard accounting was, but I found it way easier,” Sommerfeldt says. “To me, it
          just clicked.” So, Sommerfeldt applied to BYU Marriott’s School of Accountancy and, upon being accepted,
          changed his major one last time.
        </p>
        <p>
          “God knew the path I was supposed to take the whole time,” Sommerfeldt says. “My wife and I discussed and
          prayed together, and although we never understood the full picture, by focusing in on what God wanted me to
          do, we always understood what the next step was, and that helped us get to where we were supposed to be.”
        </p>
        <p>
          While he was a student in BYU Marriott’s MAcc program, Sommerfeldt felt prompted to pursue a PhD, and he
          realized that becoming a professor in accounting would fulfill his love of teaching, math, and accounting—his
          newest interest. Sommerfeldt joined the PhD prep track and worked as a research assistant for one of his
          professors.
        </p>
        <p>
          During this time, Sommerfeldt had an experience that changed his perspective. He was walking across campus one
          day during exam week—he was a new father with a lot on his mind. “I stopped in the middle of the path and just
          looked around,” he recalls. “It stood out to me that BYU is a really special place, because there are
          thousands of people walking around campus, and they’re all being trained through the light of the gospel in
          their respective fields.”
        </p>
        <p>
          His respect for BYU continued on after his graduation from the MAcc program, and Sommerfeldt earned his PhD
          from the University of Illinois in 2021—but because of the COVID-19 pandemic, job opportunities were scarce.{" "}
        </p>
        <p>
          Fortunately, Sommerfeldt found a job at Washington State University (WSU), where he continued his work in
          behavioral research. His research focuses on how companies can encourage positive employee behaviors and
          discourage negative actions through strategies like monetary incentives, recognition systems, and
          whistleblowing programs. “I want to impact practice,” he says. “I want to publish research that will help
          organizations improve and help employees find more meaning in their work, so that employees and managers
          throughout the world will enjoy going to work.”
        </p>
        <p>
          At WSU, Sommerfeldt and his department chair were the only two faculty working on behavioral research at the
          time—and the chair didn’t have much time to supervise PhD students who were also interested in behavioral
          research. “Within my first week, I was working with PhD students and helping them out with projects,”
          Sommerfeldt says.{" "}
        </p>
        <p>
          This was highly unusual, Sommerfeldt explains, as faculty without tenure at WSU didn’t normally supervise
          doctoral students. “I really appreciate that experience because I really wanted to work with PhD students, and
          it allowed me a chance to get to work with great people,” he says.
        </p>
        <p>
          Since May 2024, when he joined the ranks of the SOA, Sommerfeldt has kept in contact with PhD graduates from
          WSU, and he now works with students in the SOA’s MAcc PhD prep tracks.
        </p>
        <p>
          Returning to BYU was a dream come true for Sommerfeldt. “There’s nowhere else in the world where people are
          not just trained to be experts in their field, but they’re trained with the gospel of Jesus Christ as the
          forefront of that knowledge,” he says.
        </p>
        <p>
          He enjoys his interactions with his students and the opportunity to magnify the BYU Marriott vision of
          transforming the world through Christlike leadership. “We’ve got a lot of students who are very smart, they
          have testimonies, and I can help show them how to put those two together,” Sommerfeldt says. “They can use
          that influence in their lives and in the business world to shape society and make the business world a more
          Christlike place.”
        </p>
        <p>
          Sommerfeldt adds, “In business, I think that we have a responsibility to help people become not only leaders
          but also Christlike leaders who treat their future employees and customers—and all the people they interact
          with—the way Jesus Christ would.”
        </p>
      </PopupLightbox>
    </div>
  );
};

export default FacultyHighlights;
